/** Tab labels for the logged-in user's profile (includes Activities). */
export const PROFILE_TABS = ['All Posts', 'Photos', 'Text', 'Videos', 'Activities'] as const;

/** Tab labels for other users' profiles and AI buddy profiles (no Activities). */
export const PROFILE_TABS_PUBLIC = ['All Posts', 'Photos', 'Text', 'Videos'] as const;

export const PROFILE_TAB_ACTIVITIES = 'Activities';

/**
 * Profile tabs as translation keys plus the `action` value
 * POST /Feeds/GetUserPosts expects.
 */
export const PROFILE_TAB_KEYS = [
  { key: 'all', action: 'All' },
  { key: 'activities', action: 'Interacted' },
  { key: 'posts', action: 'Text' },
  { key: 'photos', action: 'Photos' },
  { key: 'videos', action: 'Videos' },
] as const;

/** Profile tab keys for other users' profiles (Activities excluded). */
export const PROFILE_TAB_KEYS_PUBLIC = PROFILE_TAB_KEYS.filter(
  tab => tab.key !== 'activities',
);

export type ProfileTabKey = (typeof PROFILE_TAB_KEYS)[number]['key'];

export type ProfileTabAction = 'All' | 'Photos' | 'Text' | 'Videos' | 'Interacted';

/** Mobile tab labels — Activities only on the signed-in member's own profile. */
export const getProfileTabs = (isOwnProfile: boolean): readonly string[] =>
  isOwnProfile ? PROFILE_TABS : PROFILE_TABS_PUBLIC;

/** Web tab config — Activities only on the signed-in member's own profile. */
export const getProfileTabKeys = (isOwnProfile: boolean) =>
  isOwnProfile ? PROFILE_TAB_KEYS : PROFILE_TAB_KEYS_PUBLIC;

/** Maps a profile tab label (mobile) to the GetUserPosts `action` filter. */
export const getProfileTabApiAction = (tab: string): ProfileTabAction => {
  switch (tab) {
    case 'Text':
    case 'Posts':
      return 'Text';
    case 'Photos':
      return 'Photos';
    case 'Videos':
      return 'Videos';
    case 'Activities':
      return 'Interacted';
    case 'All Posts':
    case 'All':
    default:
      return 'All';
  }
};
